import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { AutodepocaModule } from 'app/templates/autodepoca/autodepoca.module';
import { SiteAutodepocaComponent } from './site-autodepoca.component';

@NgModule({
  declarations: [SiteAutodepocaComponent],
  imports: [CommonModule, RouterModule, FuseLoadingBarModule, AutodepocaModule],
  exports: [SiteAutodepocaComponent],
})
export class SiteAutodepocaModule {}
